import CodeOutlined from '@ant-design/icons/CodeOutlined';
import Button from 'antd/es/button';
import Modal from 'antd/es/modal';
import Space from 'antd/es/space';
import React from 'react';

import { JsonSchemaEditor } from '@components/JsonSchemaEditor';

interface SchemaEditorModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (schema: Record<string, unknown>) => void;
  schema: Record<string, unknown>;
  title: string;
}

export const SchemaEditorModal: React.FC<SchemaEditorModalProps> = ({
  open,
  onClose,
  onSave,
  schema,
  title,
}) => {
  const [editingSchema, setEditingSchema] = React.useState(schema);

  React.useEffect(() => {
    if (open) {
      setEditingSchema(schema);
    }
  }, [open, schema]);

  const handleSave = () => {
    onSave(editingSchema);
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <CodeOutlined />
          <span>{title}</span>
        </Space>
      }
      centered
      open={open}
      onCancel={onClose}
      width={1000}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Save Schema
        </Button>,
      ]}
      destroyOnHidden
    >
      <JsonSchemaEditor
        value={
          editingSchema || { type: 'object', properties: {}, required: [] }
        }
        onChange={setEditingSchema}
      />
    </Modal>
  );
};
